"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var types_2 = require("./types");
var constants_1 = require("./constants");
var textService = require("../services/TextService");
var constants_2 = require("../constants");
var IncaVariableBase_1 = require("./IncaVariableBase");
var utils_1 = require("../utils");
/**
 * IncaVariableReference instances specify a dynamic reference to a particular inca variable.
 * Such a reference is defined with respect to a particular inca variable, and exposes methods
 * related to the formatting settings which are available when rendering an inca variable reference.
 */
var IncaVariableReference = /** @class */ (function (_super) {
    __extends(IncaVariableReference, _super);
    function IncaVariableReference(props) {
        return _super.call(this, props) || this;
    }
    // Get default formatting options based on IncaVariable
    IncaVariableReference.prototype.getDefaultFormattingOptions = function (currentLanguage) {
        var _this = this;
        var supportedFormatterTypes = this.getFilteredSupportedFormatterTypes(currentLanguage);
        try {
            return supportedFormatterTypes.reduce(function (obj, formatterType) {
                var _a;
                var supportedFormatter = _this.getFormatterByFormatterType(formatterType).supportedFormatterOptions;
                var filteredSupportedFormatter = supportedFormatter.filter(function (opt) { return !opt.disabled; });
                return __assign(__assign({}, obj), (_a = {}, _a[formatterType] = filteredSupportedFormatter[0], _a));
            }, {});
        }
        catch (err) {
            return {};
        }
    };
    IncaVariableReference.prototype.getFilteredSupportedFormatterTypes = function (currentLanguage) {
        var supportedFormatterTypes = this.getIncaVariable().supportedFormatterTypes;
        var question = this.getQuestion();
        return (supportedFormatterTypes || []).filter(function (supportedFormatterType) {
            var _a;
            switch (supportedFormatterType) {
                case types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT:
                    if (!((_a = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _a === void 0 ? void 0 : _a.showOther))
                        return false;
                    return true;
                case types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING:
                    if (constants_2.NON_CASING_LANGUAGE_VALUES.includes(currentLanguage))
                        return false;
                    return true;
                default:
                    return true;
            }
        });
    };
    IncaVariableReference.prototype.getFormatterByFormatterType = function (selectedFormatterType) {
        var question = this.getQuestion();
        var selectedFormatter = constants_1.IncaVariableFormatters.find(function (formatter) { return formatter.value === selectedFormatterType; });
        selectedFormatter.supportedFormatterOptions =
            selectedFormatter === null || selectedFormatter === void 0 ? void 0 : selectedFormatter.supportedFormatterOptions.map(function (formatterOption) {
                var _a;
                switch (formatterOption.value) {
                    case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TYPE_FORMAT_IMAGE:
                        return __assign(__assign({}, formatterOption), { disabled: ![
                                types_1.OPTION_TYPES.IMAGE_AND_TEXT,
                                types_1.OPTION_TYPES.IMAGE_ONLY
                            ].includes(question.selectedOptionType) });
                    case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_SPECIFY:
                        return __assign(__assign({}, formatterOption), { disabled: !((_a = question.optionSettings) === null || _a === void 0 ? void 0 : _a.showSpecify) });
                    case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_TO_DISPLAY_TEXT:
                        return __assign(__assign({}, formatterOption), { disabled: [types_1.OPTION_TYPES.IMAGE_ONLY].includes(question.selectedOptionType) });
                    case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_RANK:
                        return __assign(__assign({}, formatterOption), { disabled: ![types_1.QTYPES.RANK_ORDER].includes(question.type) });
                    default:
                        return __assign(__assign({}, formatterOption), { disabled: false });
                }
            });
        return selectedFormatter;
    };
    IncaVariableReference.prototype.getSupportedFormatterOptions = function () {
        var question = this.getQuestion();
        var incaVariable = this.getIncaVariable();
        return (incaVariable.supportedFormatterTypes || []).filter(function (supportedFormatterType) {
            var _a;
            if (supportedFormatterType ===
                types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT &&
                !((_a = question.optionSettings) === null || _a === void 0 ? void 0 : _a.showOther)) {
                return false;
            }
            return true;
        });
    };
    IncaVariableReference.prototype.processAnswerFormatting = function (langId, answerOption, formattingOptions) {
        var text = this.processTextToDisplay(langId, answerOption, formattingOptions);
        return this.processTextCasing(langId, text, formattingOptions);
    };
    IncaVariableReference.prototype.processTextToDisplay = function (langId, answerOption, formatting) {
        var _a;
        try {
            var text = '';
            switch ((_a = formatting[types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_TO_DISPLAY]) === null || _a === void 0 ? void 0 : _a.value) {
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_TO_DISPLAY_LABEL:
                    text = answerOption.label;
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_TO_DISPLAY_TEXT:
                default:
                    text = textService.getStringFromMultimediaTexts(answerOption.texts, langId, answerOption.label);
                    break;
            }
            return text;
        }
        catch (err) {
            return textService.getStringFromMultimediaTexts(answerOption.texts, langId, answerOption.label);
        }
    };
    IncaVariableReference.prototype.processTextCasing = function (langId, answerText, formatting) {
        var _a;
        try {
            var text = answerText;
            switch ((_a = formatting[types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING]) === null || _a === void 0 ? void 0 : _a.value) {
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_UPPER_FIRST:
                    text = textService.uppercaseFirstLetter(text);
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_UPPER_ALL:
                    text = text.toUpperCase();
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_LOWER_FIRST:
                    text = textService.lowercaseFirstLetter(text);
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_LOWER_ALL:
                    text = text.toLowerCase();
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_NONE:
                default:
                    text = text;
                    break;
            }
            return text;
        }
        catch (err) {
            return answerText;
        }
    };
    IncaVariableReference.prototype.processOtherFormatting = function (langId, answerOption, formatting) {
        var _a;
        try {
            var text = '';
            switch ((_a = formatting[types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT]) === null || _a === void 0 ? void 0 : _a.value) {
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_SPECIFY:
                    text = answerOption.specify;
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_TEXT:
                    text = textService.getStringFromMultimediaTexts(answerOption.texts, langId);
                    break;
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_LABEL:
                default:
                    text = constants_2.OTHER_DEFAULT_TEXT;
                    break;
            }
            return text;
        }
        catch (err) {
            return constants_2.OTHER_DEFAULT_TEXT;
        }
    };
    IncaVariableReference.prototype.processMultiOptionDisplay = function (langId, answers, formatting) {
        var _a, _b;
        try {
            switch ((_a = formatting[types_2.INCA_VARIABLE_FORMATTER_TYPES.MULTI_OPTION_DISPLAY]) === null || _a === void 0 ? void 0 : _a.value) {
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_ASC:
                    return answers.reverse();
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_RANK:
                    return [
                        answers[((_b = formatting[types_2.INCA_VARIABLE_FORMATTER_TYPES
                            .MULTI_OPTION_DISPLAY]) === null || _b === void 0 ? void 0 : _b.rank) - 1 || 0]
                    ];
                case types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_DESC:
                default:
                    return answers;
            }
        }
        catch (err) {
            return answers;
        }
    };
    IncaVariableReference.prototype.processImageReference = function (state, questionValue, formattingOptions) {
        var answer = (0, utils_1.last)(state.answers.filter(function (a) { return questionValue == a.questionValue; }));
        var mediaURLs = [];
        if (answer) {
            switch (answer.type) {
                case types_1.ATYPES.SINGLE_OPTION:
                case types_1.ATYPES.TRADE_OFF:
                    answer.option.mediaURL &&
                        mediaURLs.push(answer.option.mediaURL);
                    break;
                case types_1.ATYPES.MULTIPLE_OPTIONS:
                    answer.values.forEach(function (opt) {
                        opt.mediaURL && mediaURLs.push(opt.mediaURL);
                    });
                    mediaURLs = this.processMultiOptionDisplay('', mediaURLs, formattingOptions);
                    break;
            }
        }
        return mediaURLs;
    };
    return IncaVariableReference;
}(IncaVariableBase_1.IncaVariableBase));
exports.default = IncaVariableReference;
//# sourceMappingURL=IncaVariableReference.js.map